// extracted by mini-css-extract-plugin
export default {"productGrid":"AY-z","centerLink":"BY-z","productSection":"CY-z","item":"DY-z","ctaButton":"EY-z"};